import { Button } from 'antd';
import styled from 'styled-components';
import { APP_SHELL_THEME } from '@/styles/appShellTheme';

export const PackagePrintArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

/** Package metadata — subtle panel, not electric blue */
export const PackageMetaPanel = styled.div`
  background: rgba(${APP_SHELL_THEME.overlayRgb}, 0.03);
  border: 1px solid ${APP_SHELL_THEME.metricCardBorder};
  border-radius: 8px;
  padding: 16px;
  color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.92);
`;

/** Calculator block — same open layout as the EU6 rate calculator page */
export const PackageCalculatorSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

/** @deprecated Use PackageMetaPanel — kept as alias for any external imports */
export const PackageDetailPanel = PackageMetaPanel;

export const ActionBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
`;

export const ActionGroup = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;

/** Secondary actions on the dark shell — outline style, not bright default Ant buttons. */
export const SecondaryButton = styled(Button)`
  &.ant-btn-default:not(:disabled) {
    background: rgba(${APP_SHELL_THEME.overlayRgb}, 0.06) !important;
    border-color: ${APP_SHELL_THEME.panelBorder} !important;
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.92) !important;

    &:hover {
      background: rgba(${APP_SHELL_THEME.overlayRgb}, 0.1) !important;
      border-color: ${APP_SHELL_THEME.filterBorder} !important;
      color: ${APP_SHELL_THEME.text} !important;
    }

    &:active {
      background: rgba(${APP_SHELL_THEME.overlayRgb}, 0.14) !important;
      border-color: ${APP_SHELL_THEME.accent} !important;
      color: ${APP_SHELL_THEME.text} !important;
    }
  }

  &.ant-btn-default:disabled,
  &.ant-btn-default[disabled] {
    background: transparent !important;
    border-color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.1) !important;
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.28) !important;
    opacity: 1 !important;
    cursor: not-allowed;
  }
`;

export const DangerButton = styled(Button)`
  &.ant-btn-default.ant-btn-dangerous:not(:disabled) {
    background: rgba(255, 77, 79, 0.1) !important;
    border-color: rgba(255, 77, 79, 0.45) !important;
    color: ${APP_SHELL_THEME.negativeText} !important;

    &:hover {
      background: rgba(255, 77, 79, 0.18) !important;
      border-color: rgba(255, 77, 79, 0.65) !important;
      color: ${APP_SHELL_THEME.negativeText} !important;
    }

    &:active {
      background: rgba(255, 77, 79, 0.24) !important;
      border-color: ${APP_SHELL_THEME.negativeText} !important;
      color: ${APP_SHELL_THEME.text} !important;
    }
  }
`;
